import { PartialType, PickType } from '@nestjs/swagger';
import { RegionTimeWindowUpdatableInterface } from '../interfaces/region-time-window-updatable.interface';
import { RegionTimeWindowDto } from './region-time-window.dto';

export class RegionTimeWindowUpdateDto
  extends PartialType(
    PickType(RegionTimeWindowDto, [
      'windowStartTime',
      'windowEndTime',
      'regionTimeType',
    ]),
  )
  implements RegionTimeWindowUpdatableInterface {}
